import { render, staticRenderFns } from "./updateGraduation.vue?vue&type=template&id=deffe55c&"
import script from "./updateGraduation.vue?vue&type=script&lang=js&"
export * from "./updateGraduation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports